module.exports = __webpack_public_path__ + "img/drip.3f60b2b1.jpeg";